import { EntityCommonInfoModel, FilteredPagedQueryResult, FilteredPagedModel, CommonMultiDeleteModel } from "../../entities/common";
import { AnnouncementModel, AnnouncementCollectModel } from "../../entities/announcement";
import { apiSlice, TagTypes } from "./apiSlice";
import { getQuerySearchParams } from "../../utils";

export const announcementApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAnnouncementCommonInfo: builder.query<EntityCommonInfoModel, undefined>({
      query: () => `/announcement/commonInfo`,
      providesTags: [{ type: TagTypes.Announcement, id: "LIST" }],
    }),
    getAnnouncementFilteredPaged: builder.query<FilteredPagedQueryResult<AnnouncementModel>, FilteredPagedModel>({
      query: ({ page = 1, pageSize = 10, searchTerm = "", sortFieldName = "", descending = false, ...rest }: FilteredPagedModel) => {
        let url = `/announcement/pageable?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm}&sortFieldName=${sortFieldName}&descending=${descending}`;

        const restParams = getQuerySearchParams(rest);
        if (restParams) {
          url += `&${restParams}`;
        }

        return url;
      },
      providesTags: (result, error, arg) =>
        result
          ? [
              { type: TagTypes.Announcement, id: "PARTIAL-LIST" },
              ...result.data.map(({ id }: { id: number | string }) => ({
                type: TagTypes.Announcement,
                id,
              })),
            ]
          : [{ type: TagTypes.Announcement, id: "PARTIAL-LIST" }],
    }),
    getAnnouncement: builder.query<AnnouncementModel, number>({
      query: (announceId) => `/announcement/${announceId}`,
      providesTags: (result, error, arg) => [{ type: TagTypes.Announcement, id: arg }],
    }),
    collectAnnouncements: builder.mutation({
      query: (model: AnnouncementCollectModel) => ({
        url: "/announcement/collect",
        method: "POST",
        body: model,
      }),
      invalidatesTags: [
        { type: TagTypes.Announcement, id: "LIST" },
        { type: TagTypes.Announcement, id: "PARTIAL-LIST" },
      ],
    }),
    deleteAnnouncement: builder.mutation({
      query: (announceId) => ({
        url: `/announcement/${announceId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) =>
        error
          ? []
          : [
              { type: TagTypes.Announcement, id: arg },
              { type: TagTypes.Announcement, id: "LIST" },
            ],
    }),
    deleteMultiAnnouncements: builder.mutation({
      query: (multiDeleteModel: CommonMultiDeleteModel) => ({
        url: "/announcement/multiDelete",
        method: "DELETE",
        body: multiDeleteModel,
      }),
      invalidatesTags: (result, error, arg) =>
        error
          ? []
          : [
              ...arg.ids.map((id: number) => ({
                type: TagTypes.Announcement,
                id,
              })),
              { type: TagTypes.Announcement, id: "LIST" },
            ],
    }),
  }),
});

export const {
  useGetAnnouncementCommonInfoQuery,
  useGetAnnouncementFilteredPagedQuery,
  useGetAnnouncementQuery,
  useLazyGetAnnouncementQuery,
  useDeleteAnnouncementMutation,
  useDeleteMultiAnnouncementsMutation,
  useCollectAnnouncementsMutation,
} = announcementApi;
